module.exports = __webpack_public_path__ + "img/menu-on_03.a44e1ff8.png";